import * as React from 'react'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import Link from '@mui/material/Link'
import { Box } from '@mui/material'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'

interface TitleBreadcrumbsProps {
  originalTitleGuid: string | undefined
  originalTitleName: string | undefined
}

export function TitleBreadcrumbs({
  originalTitleGuid,
  originalTitleName,
}: TitleBreadcrumbsProps) {
  return (
    <Box mb={1}>
      <Breadcrumbs
        aria-label='breadcrumb'
        separator={<NavigateNextIcon fontSize='small' />}
      >
        <Link
          variant='subtitle2'
          underline='hover'
          color='primary'
          href={`/frumtitill/${originalTitleGuid}`}
        >
          Frumtitill - {originalTitleName}
        </Link>

        <Link href='#'> </Link>
      </Breadcrumbs>
    </Box>
  )
}
